import { render, staticRenderFns } from "./ExerciseAnswerEntityDetails.vue?vue&type=template&id=749bee49"
import script from "./ExerciseAnswerEntityDetails.vue?vue&type=script&lang=js"
export * from "./ExerciseAnswerEntityDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('749bee49')) {
      api.createRecord('749bee49', component.options)
    } else {
      api.reload('749bee49', component.options)
    }
    module.hot.accept("./ExerciseAnswerEntityDetails.vue?vue&type=template&id=749bee49", function () {
      api.rerender('749bee49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExerciseAnswerEntityDetails.vue"
export default component.exports